import axios from "axios";
import url from "../config/urlServiceConfig";

const kpiTypeAPI = {
  getAll: () => axios.get(url.kpiType),
  getById: (id) => axios.get(`${url.kpiType}/${id}`),
  create: (body) => axios.post(url.kpiType, body),
  update: (body) => axios.put(url.kpiType, body),
  delete: (id) => axios.delete(`${url.kpiType}/${id}`),
  getCreationStatuses: () => axios.get(`${url.kpiType}/CreationStatuses`),
};

export default kpiTypeAPI;
